import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { WhitelistAPI } from "../../api/api";

export default function WhitelistCreate() {
  const [ip, setIp] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await WhitelistAPI.create({ IPAddress: ip });
      navigate("/whitelist");
    } catch (err) {
      console.error("Failed to create IP:", err);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Add New Whitelist IP</h1>
      <form onSubmit={handleSubmit} className="flex space-x-2">
        <input
          type="text"
          value={ip}
          onChange={(e) => setIp(e.target.value)}
          placeholder="Enter IP address"
          className="border px-2 py-1 rounded flex-1"
        />
        <button type="submit" className="px-3 py-1 bg-green-500 text-white rounded">
          Add
        </button>
      </form>
    </div>
  );
}
